import {attempt, isError} from 'lodash';

export function isJSON(str: any) {
  return !isError(attempt(JSON.parse, str));
}

export function parse(str: any, defaultValue = null) {
  const data = attempt(JSON.parse, str);

  return isError(data) ? defaultValue : data;
}
